module.exports = __webpack_public_path__ + "img/book.9d636a98.svg";